module.exports = __webpack_public_path__ + "src/assets/models/leaves/potato_leaf.fbx";